// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"StatusSwitcher_wrapper","slider-round":"StatusSwitcher_slider-round","sliderRound":"StatusSwitcher_slider-round","switch":"StatusSwitcher_switch"};